import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {
        accountName : '',
        companyName : '',
        companySeq : 0,
        department:  '',
        email : '',
        name : '',
        role : '',
        userSeq : 0,
        contractYear : 0,
        dashboardPath : '/dashboard',
        isAdmin : false
    },
};

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        funGetSession(state, action){
            const data  = action.payload;
    state.data = { ...data };
        }
    },
});

export const sessionActions = sessionSlice.actions;
export default sessionSlice.reducer;